<div
  *ngIf="
    informationMatch.referee &&
    informationMatch.statusCode > 0 &&
    informationMatch.statusCode < 8
  "
>
  <div nz-row>
    <div nz-col nzSpan="24" class="first-second-time">
      {{ titleIncident | translate }}
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'whristle.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Referee" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.referee.name }}
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.venue">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'venue.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Location" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.venue.name }} ({{ informationMatch.venue.city }})
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.venue">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'capacity.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Capacity" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.venue.capacity | number : "1.0-0" }}
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.environment">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'weather.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Weather" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.environment.weather }}
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.environment">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'wind.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light"> {{ "Wind" | translate | uppercase }}: </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.environment.wind }}
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.environment">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'temperature.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Temperature" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.environment.temperature }}
        </span>
      </div>
    </div>
  </div>
  <div nz-row *ngIf="informationMatch.environment">
    <div nz-col nzSpan="12" class="incident">
      <div nz-col nzSpan="2" class="icon-info">
        <img
          alt="logo"
          nz-image
          width="'auto'"
          height="'auto'"
          alt="logo"
          title=""
          [src]="urlIMG + 'humedity.png'"
          class="icon-svg"
        />
      </div>
      <div
        nz-col
        nzSpan="22"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'start',
          'justify-content': 'start'
        }"
      >
        <span class="text-light">
          {{ "Humidity" | translate | uppercase }}:
        </span>
      </div>
    </div>
    <div nz-col nzSpan="12" class="incident">
      <div
        nz-col
        nzSpan="24"
        class="text-incident"
        [ngStyle]="{
          'text-align': 'end',
          'justify-content': 'end'
        }"
      >
        <span class="text-bold">
          {{ informationMatch.environment.humidity }}
        </span>
      </div>
    </div>
  </div>
</div>

<app-no-result
  *ngIf="
    !(
      informationMatch.referee &&
      informationMatch.statusCode > 0 &&
      informationMatch.statusCode < 8
    )
  "
  message="NotAvalaibleInformation"
>
</app-no-result>
